<script>
import Card from "./Card.vue";
import freshDesk from "@/utils/freshDesk";

export default {
  data() {
    return {
      opened: false
    };
  },
  props: {
    effect: {
      type: String,
      default: "show-from-bottom",
      required: false
    },
    withButton: {
      type: Boolean,
      default: true,
      required: false
    },
    outsideOpened: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  components: {
    Card
  },
  methods: {
    toggleFreshDesk() {
      this.opened = !this.opened;

      if (this.opened) {
        freshDesk.open();
        setTimeout(() => {
          this.opened = false;
        }, 1000);
      } else {
        freshDesk.close();
      }
    }
  }
};
</script>

<template>
  <div class="new-master">
    <!-- <transition :name="effect" mode="in-out">
      <div
        class="whats-share"
        :class="{'from-right': !withButton}"
        v-show="opened || outsideOpened"
      >
        <div class="header">
          <div class="donie">
            <img src="/static/whats-share/donie.svg" height="80px" alt="Donie" title="Donie" />
          </div>

          <p>Por favor, escolha algum canal para conversar e teremos todo o prazer em ajudá-lo!</p>
        </div>

    <div class="body">-->
    <!-- <Card
            title="Quero tirar dúvidas"
            responsible="André - Setor de Marketing"
            link="whatsapp://send?phone=5553981095409"
    />-->
    <!-- <Card
            title="Abrir ticket para a Donamaid"
            responsible="Donamakers"
            :whats="false"
            link="https://donamaid.freshdesk.com/support/tickets/new"
          />
        </div>
      </div>
    </transition>-->

    <div
      v-if="withButton"
      id="btn-whats-share"
      class="button-float"
      :class="{active: opened}"
      @click="toggleFreshDesk"
    >
      <img
        :src="'/static/whats-share/donie.svg'"
        class="icon-default donie"
        alt="Suporte"
        title="Suporte"
      />
      <img src="/static/whats-share/close.svg" class="icon-active" alt="Fechar" title="Suporte" />
    </div>
  </div>
</template>

<style scoped>
div.new-master {
  overflow: hidden;
}

.whats-share {
  position: fixed;
  bottom: 90px;
  right: 38px;
  width: 375px;
  height: auto;
  max-height: calc(100% - 115px);
  max-width: calc(100% - 20px);
  background-color: #e2e2e2;
  border-radius: 12px;
  overflow-y: auto;
  box-shadow: 0px 4px 30px 0 rgba(0, 0, 0, 0.1);
  z-index: 9999;
}

#btn-whats-share {
  z-index: 9;
}

.whats-share.from-right {
  right: 90px;
  bottom: 90px;
}

.whats-share .header {
  background-color: var(--purple);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #fff;
  text-align: center;
  padding-bottom: 50px;
  padding-left: 20px;
  padding-right: 20px;
}

.whats-share .header p {
  font-size: 16px;
}

.whats-share .body {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: -50px;
}

.whats-share .donie {
  margin-top: 20px;
}

.whats-share::-webkit-scrollbar {
  width: 0.02rem;
}
.whats-share::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0);
}
.whats-share::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0);
  transition: background 0.3s ease;
}
.whats-share:hover::-webkit-scrollbar-thumb {
  background: rgba(200, 200, 200, 0.5);
}

.show-from-bottom-enter-active,
.show-from-bottom-leave-active {
  transition: all 0.25s ease-out;
}

.show-from-bottom-enter,
.show-from-bottom-leave-to {
  transform: translateY(60px);
  opacity: 0;
}

.show-from-right-enter-active,
.show-from-right-leave-active {
  transition: all 0.25s ease-out;
}

.show-from-right-enter,
.show-from-right-leave-to {
  transform: translateX(100%);
  opacity: 0;
}

.button-float {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  bottom: 20px;
  right: 38px;
  width: 55px;
  height: 55px;
  background-color: rgb(96, 50, 133);
  border-radius: 100%;
  cursor: pointer;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.06), 0 2px 32px rgba(0, 0, 0, 0.16);
  z-index: 2;
}

.button-float img {
  position: absolute;
  top: calc(50% - 8px);
  left: calc(50% - 8px);
  display: block;
  width: 16px;
  height: 16px;
}
.button-float img.donie {
  position: absolute;
  top: calc(50% - 22px);
  left: calc(50% - 20px);
  display: block;
  width: 40px;
  height: 40px;
}

.button-float img.icon-default {
  transition: opacity 0.3s, transform 0.3s;
}

.button-float img.icon-active {
  transition: opacity 0.3s, transform 0.3s;
  transform: rotate(-180deg) scale(0.5);
  opacity: 0;
}

.button-float.active .icon-active {
  transform: rotate(0deg) scale(1);
  opacity: 1;
}

.button-float.active .icon-default {
  transform: rotate(180deg) scale(0.5);
  opacity: 0;
}

@media (max-width: 768px) {
  .button-float {
    right: 5px;
    bottom: 5px;
  }

  .whats-share {
    right: 5px;
    bottom: 70px;
  }

  .whats-share.from-right {
    right: 10px;
    bottom: 90px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/_Shared/WhatsShare/Index.vue